<template>
  <b-modal
    id="jumpBall"
    ok-only
    no-close-on-backdrop
    :visible="true"
    ok-title="Accept"
    body-class="text-center"
    size="xl"
    hide-footer
    @hide="stopPendingGame"
    @close="stopPendingGame"
  >
    <template #modal-title>
      Jump Ball <feather-icon
        :icon="isMuted ? 'VolumeXIcon' : 'Volume2Icon' "
        size="20"
        role="button"
        @click="$emit('toggleSound')"
      />
    </template>
    <b-spinner
      v-if="isProcessing"
      type="grow"
      class="text-center"
      label="Loading..."
    />
    <iframe
      id="gameFrameContent"
      style="height: 80vh;width: 100%;"
      frameBorder="0"
    />
  </b-modal>

</template>
<script>
import { BModal, BSpinner } from 'bootstrap-vue'
// import { loadScript } from 'vue-plugin-load-script'

export default {
  components: {
    BModal,
    BSpinner,
  },
  props: {
    isMuted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isProcessing: true,
    }
  },
  async created() {
    const scripts = [
      '/jumpBall/scripts/supportcheck.js',
      '/jumpBall/scripts/offlineclient.js',
      '/jumpBall/scripts/main.js',
      '/jumpBall/scripts/register-sw.js',
    ]
    let html = ' <div id="gameContainer" />'
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < scripts.length; i++) {
      html += `<script src="${scripts[i]}"></`
      html += 'script>'
    }
    setTimeout(() => {
      const iframe = document.getElementById('gameFrameContent')
      iframe.contentWindow.document.open()
      iframe.contentWindow.document.write(html)
      iframe.contentWindow.document.close()
      iframe.contentWindow.document.addEventListener('jumpBallGameOver', () => {
        this.$emit('gameOver')
      })
      this.isProcessing = false
    }, 1000)
  },
  methods: {
    stopPendingGame() {
      this.$emit('gameOver')
    },
  },
}
</script>
<style>
#carRacing .modal-header .close {
  display:none;
}
</style>
